export const routes = {
  cookiesPolicy: {
    path: "/cookies-policy",
    name: "cookies-policy",
  },
  cookiesPolicyDocument: {
    path: "/cookies-policy-document",
    name: "cookies-policy-document",
  },
};
